import { Edit } from "@mui/icons-material";
import { Box, IconButton, TextField } from "@mui/material";
import DrawerWrapper from "components/DrawerWrapper";
import { useEffect, useState } from "react";
// import SelectService from "./selectService";
import { DesktopDatePicker } from "@mui/lab";
import { handleKeyDown } from "utils/keyDownPrevent";
import { StyledTextField } from "views/task-view/Details/Fields";
import { DateTypes } from "data/constants";
import moment from "moment";
import LoadingButton from "components/LoadingButton";
import { useMutation, useQueryClient } from "react-query";
import { addRequestTask, editRequestTask } from "api/services/tasks";
import { snack } from "components/toast";
import { updateRequestDocument } from "api/services/storage";

const createDocumentDefaultValues = {
    documentName: "",
    description: "",
    uploadDocs: null,
};

function EditDocument({ open, setOpen, editData }: any) {
    const [state, setState] = useState<any>(editData || createDocumentDefaultValues);
    const [error, setError] = useState<string | null>(null);
    const clientId = localStorage.getItem("clientId") || "";
    const queryClient = useQueryClient();

    useEffect(() => {
        setState(editData || createDocumentDefaultValues);
    }, [open]);

    const { mutate, isLoading } = useMutation(updateRequestDocument, {
        onSuccess: () => {
            snack.success("Requested Document Edited Successfully");
            setState(createDocumentDefaultValues);
            setOpen(false);
            queryClient.invalidateQueries("requested-documents");
        },
        onError: (err: any) => {
            snack.error(err.response.data.message);
        },
    });

    const handleSubmit = () => {
        if (!state.documentName) {
            snack.error("Please enter a document name");
            return;
        }
        
        mutate({
            id: state.id,
            data: { ...state },
        });
    };

    return (
        <DrawerWrapper
            open={open}
            setOpen={() => {
                setState(createDocumentDefaultValues);
                setOpen(false);
            }}
            title="Document Request Edit"
        >
            <Box display="flex" flexDirection="column" gap={2} mt={1}>
                <TextField label="Document Name" fullWidth variant="outlined" placeholder="Select Service" value={state.documentName} onChange={(e) => setState({ ...state, documentName: e.target.value })} />
                <TextField label="Upload Docs" fullWidth disabled variant="outlined" placeholder="Upload Docs" value={state.uploadDocs} onChange={(e) => setState({ ...state, uploadDocs: e.target.value })} />
                <TextField
                    label="Description"
                    placeholder="Write your notes here..."
                    rows={3}
                    multiline
                    variant="outlined"
                    fullWidth
                    value={state.description}
                    onChange={(e) => setState({ ...state, description: e.target.value })}
                />
                <LoadingButton
                    loading={isLoading}
                    disabled={isLoading}
                    fullWidth
                    onClick={() => handleSubmit()}
                    loadingColor="white"
                    title="Request Edit"
                    color="secondary"
                    type="submit"
                />
            </Box>
        </DrawerWrapper>
    );
}

export default EditDocument;